export const generateKey = (index: any, generatedWord: string): string =>
  `${index}_${generatedWord}`;
